import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgActivities = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.216 4.00246C14.6886 3.9694 15.1196 4.27258 15.2482 4.72861L17.3284 12.1053H20C20.5523 12.1053 21 12.553 21 13.1053C21 13.6576 20.5523 14.1053 20 14.1053H16.5714C16.1237 14.1053 15.7305 13.8076 15.609 13.3767L14.6283 9.89938L13.3718 19.1348C13.3094 19.5937 12.94 19.9497 12.4791 19.9952C12.0183 20.0407 11.5864 19.7637 11.4355 19.3259L9.00771 12.282L8.23296 13.331C8.04442 13.5862 7.74592 13.7369 7.42857 13.7369H4C3.44772 13.7369 3 13.2891 3 12.7369C3 12.1846 3.44772 11.7369 4 11.7369H6.92397L8.52895 9.56381C8.74962 9.26503 9.11772 9.11318 9.48486 9.16947C9.85201 9.22575 10.1577 9.48089 10.2788 9.83206L11.9567 14.7004L13.2948 4.86521C13.3587 4.39573 13.7433 4.03551 14.216 4.00246Z"
	})
});
export default SvgActivities;
